import { render, staticRenderFns } from "./locationTestA.vue?vue&type=template&id=8837c206&scoped=true&"
import script from "./locationTestA.vue?vue&type=script&lang=js&"
export * from "./locationTestA.vue?vue&type=script&lang=js&"
import style0 from "./locationTestA.vue?vue&type=style&index=0&id=8837c206&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8837c206",
  null
  
)

export default component.exports